(function() {
  function syncFocusability(el) {
    var isHidden = el.getAttribute('aria-hidden') === 'true';
    var focusableEls = [];

    if (el.matches && el.matches('a[href], button, input, select, textarea')) {
      focusableEls.push(el);
    }
    el.querySelectorAll('a[href], button, input, select, textarea').forEach(function(f) {
      focusableEls.push(f);
    });

    if (isHidden) {
      focusableEls.forEach(function(f) {
        if (f === document.activeElement) {
          document.activeElement.blur();
        }
      });
    }

    focusableEls.forEach(function(f) {
      if (isHidden) {
        f.setAttribute('tabindex', '-1');
      } else {
        f.removeAttribute('tabindex');
      }
    });
  }

  function observeSlides() {
    document.querySelectorAll(
      '.announcement-slider__slide, .slideshow__slide'
    ).forEach(function(slide) {
      if (!slide.dataset.a11yObserved) {
        slide.dataset.a11yObserved = 'true';
        observer.observe(slide, { attributes: true, subtree: true, attributeFilter: ['aria-hidden'] });
        syncFocusability(slide);
        slide.querySelectorAll('[aria-hidden]').forEach(function(child) {
          syncFocusability(child);
        });
      }
    });
  }

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
        syncFocusability(mutation.target);
      }
    });
    observeSlides();
  });

  observeSlides();

  document.querySelectorAll(
    '.announcement-slider, .hero'
  ).forEach(function(container) {
    observer.observe(container, {
      childList: true,
      subtree: true
    });
  });

  document.querySelectorAll('.announcement-slider, .hero').forEach(function(container) {
    container.addEventListener('focusin', function() {
      var instance = Flickity.data(container);
      if (instance) instance.pausePlayer();
    });

    container.addEventListener('focusout', function(evt) {
      if (!container.contains(evt.relatedTarget)) {
        var instance = Flickity.data(container);
        if (instance) instance.playPlayer();
      }
    });
  });
})();